export function isDesignRenderRoute(pathname: string) {
  const pathParts = pathname.split("/").filter(Boolean);

  return (
    pathParts[0] === "render" ||
    (pathParts[0] === "designer" && pathParts[2] === "render")
  );
}
